import { render, staticRenderFns } from "./SalespersonComponent.vue?vue&type=template&id=4d659d5a&"
import script from "./SalespersonComponent.vue?vue&type=script&lang=js&"
export * from "./SalespersonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports